export default __webpack_public_path__ + "static/media/logo.c5e8364e.png";